// 版权申明
const copyright = {
  title: '云智造平台',
  copr: 'Copyright &copy; 2018-2019 平台版权所有 增材制造云平台 <a href="http://beian.miit.gov.cn">京ICP备10010006号-6</a><a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502047888"><img src="/static/images/police.png" style="vertical-align:middle;margin:0 2px 1px 20px" />京公网安备 11010502047888号</a></div>',
  links: {
    clause: '用户条款',
    declare: '法律声明'
  }
}

// 导航
const navs = {
  nav: {
    index: '首页',
    print3D: '3D打印服务',
    market: '创客集市'
  },
  userMenu: {
    personal: '个人中心',
    profile: '个人信息',
    factory: '用户中心',
    order: '我的订单',
    print3D: '3D打印',
    inquiry: '报价咨询',
    maintenance: '管理中心',
    space: '我的动态',
    seller: '卖家中心',
    shop: '我要开店',
    message: '消息中心',
    logout: '注销'
  }
}

// 用户登录、注册、找回密码
const userform = {
  field: {
    account: '账户',
    userid: '账号',
    username: '姓名',
    password: '密码',
    confirmPwd: '确认密码',
    tel: '电话',
    mobile: '手机号',
    regMobile: '注册手机号',
    email: '邮箱',
    code: '验证码',
    photo: '头像',
    sex: '性别',
    region: '地区',
    industry: '行业',
    address: '唯一编码'
  },
  sex: {
    male: '先生',
    female: '女士'
  },
  hint: {
    mobile: {
      repeat: '该手机号已注册！'
    },
    code: {
      get: '获取验证码',
      got: '有效期还剩%秒',
      send: '发送验证码',
      sent: '已发送%至',
      frequent: '1小时内同一手机号%类短信次数不能超过3次'
    },
    password: {
      getback: '找回密码',
      forgot: '忘记密码',
      format: '6－16位%，区分大小写',
      confirm: '请再次确认密码！',
      over: '密码长度为6－16位！',
      diff: '两次输入不一致！',
      plain: '您快速注册的临时密码为【%】，请尽快修改！',
      modified: '您已成功修改密码，请牢记！'
    }
  },
  intensity: {
    none: '密码强度',
    low: '弱',
    mid: '中',
    high: '强'
  },
  login: {
    auto: '自动登录',
    reg: '注册账户'
  },
  forgot: {
    getback: '立即找回',
    login: '返回登录'
  },
  industries:[
    '汽车',
    '动力设备',
    '特种设备',
    '军工',
    '汽车零部件',
    '电子',
    '材料',
  ]
}

// 开店
const openShop = {
  header: '我要开店',
  warning: '您填写的信息将在店铺前台展示给买家，请认真填写！',
  form: {
    name: '店铺名称',
    name_h: '请输入店铺名称',
    brief: '店铺简介',
    brief_h: '简短一两句话描述自己的特色',
    address: '经营地址',
    area_h: '请选择省/直辖市',
    address_h: '请输入详细地址',
    agree: '我同意相关协议'
  },
  btn_ok: '快速开店',
  msg: {
    required: '必填项',
    name_only: '店铺名已被使用',
    name_can_use: '店铺名称可用',
    minLength2: '至少输入两个字'
  }
}

export {
  copyright, // 版权申明
  navs, // 导航
  userform, // 用户登录、注册、找回密码
  openShop // 开店
}



// WEBPACK FOOTER //
// ./src/commons/locale/charset/zh_cn/components.js